import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Button, Row } from 'react-bootstrap';

const CompanyHeader = () => {
  return (
    <Card>
      <Card.Body>
        <Row className="flex-between-center">
          <Col md>
            <h5 className="mb-2 mb-md-0">Компанийн төлбөр</h5>
          </Col>
          <Col xs="auto">
            <Button
              as={Link}
              to="/company/company-list"
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
            >
              Болих
            </Button>
            <Button variant="primary" type="submit">
              Хадгалах
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CompanyHeader;
